// This file is auto-generated by next/scripts/writeSiteSettings.ts
// do not edit directly
export const legalFooter = {
  copyRaw: [
    {
      style: "normal",
      _key: "8ee37ee70b17",
      markDefs: [],
      children: [
        {
          marks: [],
          text: "Brex Inc. | 650 S 500W Suite 300 | Salt Lake City, UT 84101",
          _key: "48301a7fc1f50",
          _type: "span",
        },
      ],
      _type: "block",
    },
    {
      style: "normal",
      _key: "6d69544d2296",
      markDefs: [
        {
          _type: "link",
          link: { toExternal: "https://www.fdic.gov/about/what-we-do" },
          href: "https://www.fdic.gov/about/what-we-do",
          _key: "05660b65ccdc",
        },
        {
          _type: "link",
          link: { toExternal: "https://brokercheck.finra.org/" },
          href: "https://brokercheck.finra.org/",
          _key: "e2f7a6e1b383",
        },
        {
          href: "https://www.sipc.org/",
          _key: "ea77ac7c27cc",
          _type: "link",
          link: { toExternal: "https://www.sipc.org/" },
        },
      ],
      children: [
        {
          _type: "span",
          marks: [],
          text: "Brex is a financial technology company, not a bank. The Brex business account consists of Checking, a commercial checking account provided by Column N.A., Member ",
          _key: "2ed21fa4395c0",
        },
        {
          _type: "span",
          marks: ["05660b65ccdc"],
          text: "FDIC",
          _key: "2ed21fa4395c1",
        },
        {
          _key: "2ed21fa4395c2",
          _type: "span",
          marks: [],
          text: ", and Treasury and Vault, cash management services provided by Brex Treasury LLC, Member ",
        },
        {
          marks: ["e2f7a6e1b383"],
          text: "FINRA",
          _key: "2ed21fa4395c3",
          _type: "span",
        },
        { text: "/", _key: "2ed21fa4395c4", _type: "span", marks: [] },
        {
          text: "SIPC",
          _key: "2ed21fa4395c5",
          _type: "span",
          marks: ["ea77ac7c27cc"],
        },
        { text: ".", _key: "2ed21fa4395c6", _type: "span", marks: [] },
      ],
      _type: "block",
    },
    {
      _type: "block",
      style: "normal",
      _key: "79506882eb0b",
      markDefs: [
        {
          _type: "link",
          link: {
            toExternal: "https://www.brex.com/legal/brex-cash-partner-banks",
          },
          href: "https://www.brex.com/legal/brex-cash-partner-banks",
          _key: "a5facb70754f",
        },
        {
          _type: "link",
          link: { toExternal: "https://www.fdic.gov/about/what-we-do" },
          href: "https://www.fdic.gov/about/what-we-do",
          _key: "aa1807a6850e",
        },
        {
          link: {
            toExternal: "https://www.brex.com/statement-of-financial-condition",
          },
          href: "https://www.brex.com/statement-of-financial-condition",
          _key: "1cb787bd51a5",
          _type: "link",
        },
      ],
      children: [
        {
          _type: "span",
          marks: [],
          text: "Securities are offered through Brex Treasury LLC. Funds in Treasury are not FDIC-insured. Funds in Vault at ",
          _key: "b779c227cd0c0",
        },
        {
          _key: "b779c227cd0c1",
          _type: "span",
          marks: ["a5facb70754f"],
          text: "program banks",
        },
        {
          marks: [],
          text: " are eligible for ",
          _key: "b779c227cd0c2",
          _type: "span",
        },
        {
          marks: ["aa1807a6850e"],
          text: "FDIC",
          _key: "b779c227cd0c3",
          _type: "span",
        },
        {
          _type: "span",
          marks: [],
          text: " insurance. Funds are not FDIC-insured until they arrive at program banks. Conditions apply. Investing in securities involves risk and loss of money. Yield and return are variable and fluctuate. Past performance is not a guarantee of future results. This is not an offer to, or implied offer, or a solicitation to, buy or sell any securities. Brex Treasury LLC does not provide legal, tax, or investment advice. The latest statement of financial condition for Brex Treasury LLC is available ",
          _key: "b779c227cd0c4",
        },
        {
          _key: "b779c227cd0c5",
          _type: "span",
          marks: ["1cb787bd51a5"],
          text: "here",
        },
        { text: ".", _key: "b779c227cd0c6", _type: "span", marks: [] },
      ],
    },
    {
      markDefs: [],
      children: [
        {
          marks: [],
          text: "The Brex Mastercard® Corporate Credit Card is issued by Emigrant Bank or Fifth Third Bank N.A, pursuant to licenses by Mastercard International Inc., or Airwallex (Netherlands) B.V. Mastercard is a registered trademark, and the circles design is a trademark of Mastercard International Inc. The Brex Commercial Card is issued by Sutton Bank, pursuant to a license from Visa® U.S.A. Inc. Valid only in the US. Card can be used where Visa® debit cards are accepted. No ATM access. All loans are subject to approval, including underwriting, credit, and collateral approval, as well as availability restrictions. Nothing herein should be construed as a commitment to lend.\n",
          _key: "659bb36d51fd0",
          _type: "span",
        },
      ],
      _type: "block",
      style: "normal",
      _key: "efd095851d8d",
    },
    {
      markDefs: [
        {
          _key: "f2914605fbd0",
          _type: "link",
          link: { toExternal: "https://www.brex.com/legal/state-disclosures" },
          href: "https://www.brex.com/legal/state-disclosures",
        },
      ],
      children: [
        {
          marks: [],
          text: "Certain payment services are provided by Brex Payments LLC, a ",
          _key: "6d8e7a8beb030",
          _type: "span",
        },
        {
          marks: ["f2914605fbd0"],
          text: "licensed money transmitter",
          _key: "6d8e7a8beb031",
          _type: "span",
        },
        {
          _key: "6d8e7a8beb032",
          _type: "span",
          marks: [],
          text: " (NMLS #2035354).",
        },
      ],
      _type: "block",
      style: "normal",
      _key: "c1404db2533a",
    },
    {
      _key: "325c5b8a3293",
      markDefs: [],
      children: [
        {
          _type: "span",
          marks: [],
          text: "Some Brex products have associated fees. Plans start at $0 per user, per month, and more advanced features are available for $12 per user, per month.",
          _key: "6aff7854cb000",
        },
      ],
      _type: "block",
      style: "normal",
    },
  ],
};
export const selectedBannerId = "6e06ef97-5bd5-4f96-a011-b2437ea0cb7b";
export const allBanners = {
  "0897ba5d-858a-4567-ac7b-8141c98adede": {
    _id: "0897ba5d-858a-4567-ac7b-8141c98adede",
    _updatedAt: "2024-02-29T16:13:40Z",
    theme: "PrimaryInk",
    icon: {
      color: null,
      mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill=currentColor xmlns="http://www.w3.org/2000/svg">\n<g clip-path="url(#clip0_6620_871)">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M4.97183 10.4917C5 10.8023 5.21127 11 5.50704 11C5.78873 11 6 10.8023 6.02817 10.5199C6.52016 6.78525 6.63336 6.76387 10.4983 6.03383L10.5211 6.02952C10.8028 5.98716 11 5.78947 11 5.50706C11 5.21053 10.7887 4.99872 10.5211 4.97047C6.64789 4.43389 6.52113 4.3068 6.02817 0.494223C6 0.197689 5.78873 0 5.50704 0C5.21127 0 5 0.197689 4.97183 0.508344C4.51102 4.21832 4.34094 4.25005 0.577071 4.95215L0.478873 4.97047C0.197183 5.01284 0 5.21053 0 5.50706C0 5.80359 0.197183 5.98716 0.535211 6.02952C4.35211 6.63671 4.50704 6.74968 4.97183 10.4917ZM14.5 24C14.1424 24 13.8563 23.7376 13.7967 23.3559C12.8789 16.8914 12.0088 16.0565 5.6675 15.2097C5.27415 15.162 5 14.8638 5 14.494C5 14.1243 5.27415 13.838 5.67942 13.7903C12.0326 13.0866 12.9385 12.1086 13.7967 5.64407C13.8563 5.2624 14.1305 5 14.5 5C14.8695 5 15.1437 5.2624 15.2033 5.64407C16.0972 12.1086 16.9793 13.0508 23.3325 13.7903C23.7258 13.838 24 14.1243 24 14.494C24 14.8757 23.7258 15.162 23.3325 15.2097C16.9674 15.9134 16.0615 16.8914 15.2033 23.3559C15.1437 23.7376 14.8695 24 14.5 24Z" fill=currentColor/>\n</g>\n<defs>\n<clipPath id="clip0_6620_871">\n<rect width="24" height="24" fill="white"/>\n</clipPath>\n</defs>\n</svg>',
      title: "AI",
    },
    iconColor: "single",
    size: "sml",
    textColor: "textPrimary",
    bannerBlockContentRaw: [
      {
        _key: "84a72e2fa4fb",
        markDefs: [
          {
            _type: "link",
            link: { to: "/platform/brex-ai" },
            _key: "d315276552dc",
          },
        ],
        children: [
          {
            marks: ["d315276552dc"],
            text: "Reduce expense busywork by 10x with Brex AI >",
            _key: "c39f840077ce0",
            _type: "span",
          },
        ],
        _type: "block",
        style: "normal",
      },
    ],
    optOutPages: ["/sales", "/signup", "/platform/brex-ai"],
    optOutPageTypes: ["paidPage", "helpCenterArticle", "jobPage"],
  },
  "0f26bcac-5f17-4fbb-ab1c-edf432518cdc": {
    _id: "0f26bcac-5f17-4fbb-ab1c-edf432518cdc",
    _updatedAt: "2025-05-20T12:54:15Z",
    theme: "PrimaryInk",
    icon: null,
    iconColor: "single",
    size: "sml",
    textColor: "textPrimary",
    bannerBlockContentRaw: [
      {
        children: [
          { _type: "span", marks: [], text: "🎉 ", _key: "4475462db6c00" },
          {
            _key: "09620bba2184",
            _type: "span",
            marks: ["df131c2b43d9"],
            text: "Meet Brex for Zip! Faster procurement and payments in one workflow →",
          },
        ],
        _type: "block",
        style: "normal",
        _key: "670a5d460cf8",
        markDefs: [
          {
            link: {
              noFollow: false,
              toExternal: "https://www.brex.com/brex-for-zip-procurement",
            },
            _key: "df131c2b43d9",
            _type: "link",
          },
        ],
      },
    ],
    optOutPages: ["/sales", "/signup"],
    optOutPageTypes: ["paidPage", "helpCenterArticle", "jobPage"],
  },
  "15b3d1dc-efdb-4517-b3b9-1b813dcedcf8": {
    _id: "15b3d1dc-efdb-4517-b3b9-1b813dcedcf8",
    _updatedAt: "2024-03-15T22:52:57Z",
    theme: "PrimaryInk",
    icon: null,
    iconColor: "single",
    size: "sml",
    textColor: "textPrimary",
    bannerBlockContentRaw: [
      {
        _key: "6b0432e6d30a",
        markDefs: [
          {
            link: { to: "/resources/automate-accounts-payable-with-ai" },
            _key: "1657bfeb84a7",
            _type: "link",
          },
        ],
        children: [
          { text: "📣 ", _key: "7bb49de9044e0", _type: "span", marks: [] },
          {
            _key: "559ddc3932c9",
            _type: "span",
            marks: ["1657bfeb84a7"],
            text: "New IDC report on AP automation! Get your free copy >",
          },
        ],
        _type: "block",
        style: "normal",
      },
    ],
    optOutPages: ["/sales", "/signup"],
    optOutPageTypes: ["paidPage", "helpCenterArticle", "jobPage"],
  },
  "1788b800-95be-4265-a1c5-0698d2c19c4c": {
    _id: "1788b800-95be-4265-a1c5-0698d2c19c4c",
    _updatedAt: "2024-10-23T13:52:48Z",
    theme: "PrimaryInk",
    icon: null,
    iconColor: "single",
    size: "sml",
    textColor: "textPrimary",
    bannerBlockContentRaw: [
      {
        children: [
          {
            _type: "span",
            marks: ["145867fa77ab"],
            text: "🔥 Webinar: Get a live demo of BrexPay for Navan. Register now >",
            _key: "e4739577a7cb",
          },
        ],
        _type: "block",
        style: "normal",
        _key: "052a4e60e725",
        markDefs: [
          {
            _key: "145867fa77ab",
            _type: "link",
            link: {
              noFollow: false,
              to: "/resources/reimagining-global-travel-payments-register",
            },
          },
        ],
      },
    ],
    optOutPages: ["/sales", "/signup"],
    optOutPageTypes: ["paidPage", "helpCenterArticle", "jobPage"],
  },
  "1b0b6ed1-ed82-4267-8024-2fd1551e22c1": {
    _id: "1b0b6ed1-ed82-4267-8024-2fd1551e22c1",
    _updatedAt: "2024-02-29T16:13:40Z",
    theme: "PrimaryInk",
    icon: {
      color:
        '<svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M13.5629 4.89329C11.6112 4.24273 9.46846 4.52968 7.75671 5.67085L5.92707 6.89061L4.26297 8.00001L5.92707 9.10941L10.263 12L8.51064 13.1682L5.82852 12.0954L5.37504 11.914L4.9117 12.0684L2.95837 12.7195C1.07774 13.3464 0.514287 15.7332 1.91602 17.135L4.64044 19.8594C7.27459 22.4935 11.3783 22.9609 14.5373 20.9865L29.8507 11.4157C31.3672 10.4678 31.5393 8.32517 30.1933 7.14748L29.5796 6.61049C27.1349 4.47137 23.6394 4.02293 20.7339 5.47569L18.5644 6.56045L13.5629 4.89329ZM9.23591 7.88965C10.263 7.20495 11.5486 7.03277 12.7196 7.42311L18.245 9.26492L18.769 9.43957L19.263 9.19258L21.9265 7.86083C23.8635 6.89232 26.1938 7.19128 27.8236 8.61736L28.4373 9.15435L13.124 18.7252C11.018 20.0415 8.28216 19.7299 6.52606 17.9738L3.80164 15.2494L5.29162 14.7527L8.17148 15.9046L8.82269 16.1651L9.40627 15.7761L13.4063 13.1094L15.0704 12L13.4063 10.8906L9.07037 8.00001L9.23591 7.88965ZM2.66667 28H21.3333V25.3333H2.66667V28Z" fill="currentColor"/>\n</svg>',
      mono: '<svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M13.5629 4.89329C11.6112 4.24273 9.46846 4.52968 7.75671 5.67085L5.92707 6.89061L4.26297 8.00001L5.92707 9.10941L10.263 12L8.51064 13.1682L5.82852 12.0954L5.37504 11.914L4.9117 12.0684L2.95837 12.7195C1.07774 13.3464 0.514287 15.7332 1.91602 17.135L4.64044 19.8594C7.27459 22.4935 11.3783 22.9609 14.5373 20.9865L29.8507 11.4157C31.3672 10.4678 31.5393 8.32517 30.1933 7.14748L29.5796 6.61049C27.1349 4.47137 23.6394 4.02293 20.7339 5.47569L18.5644 6.56045L13.5629 4.89329ZM9.23591 7.88965C10.263 7.20495 11.5486 7.03277 12.7196 7.42311L18.245 9.26492L18.769 9.43957L19.263 9.19258L21.9265 7.86083C23.8635 6.89232 26.1938 7.19128 27.8236 8.61736L28.4373 9.15435L13.124 18.7252C11.018 20.0415 8.28216 19.7299 6.52606 17.9738L3.80164 15.2494L5.29162 14.7527L8.17148 15.9046L8.82269 16.1651L9.40627 15.7761L13.4063 13.1094L15.0704 12L13.4063 10.8906L9.07037 8.00001L9.23591 7.88965ZM2.66667 28H21.3333V25.3333H2.66667V28Z" fill="currentColor"/>\n</svg>',
      title: "Plane Departing",
    },
    iconColor: "single",
    size: "sml",
    textColor: "textPrimary",
    bannerBlockContentRaw: [
      {
        children: [
          {
            _type: "span",
            marks: [],
            text: "Webinar - Discover why business travel will never be the same. April 19, 9 am PT  ",
            _key: "f4ead9d26fea0",
          },
          {
            marks: ["96ff6fd73657"],
            text: "Register now",
            _key: "42d016d9670c",
            _type: "span",
          },
        ],
        _type: "block",
        style: "normal",
        _key: "4852c94e4397",
        markDefs: [
          {
            _key: "96ff6fd73657",
            _type: "link",
            link: {
              toExternal:
                "https://www.brex.com/resources/why-business-travel-will-never-be-the-same",
            },
          },
        ],
      },
    ],
    optOutPages: ["/sales", "/signup", "/product-tour"],
    optOutPageTypes: [
      "paidPage",
      "helpCenterArticle",
      "jobPage",
      "legalPage",
      "pressRelease",
    ],
  },
  "2ac86c6a-9449-45d9-b8ce-6fe177951155": {
    _id: "2ac86c6a-9449-45d9-b8ce-6fe177951155",
    _updatedAt: "2024-02-29T16:13:40Z",
    theme: "PrimaryInk",
    icon: {
      color: null,
      mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill=currentColor xmlns="http://www.w3.org/2000/svg">\n<g clip-path="url(#clip0_6620_871)">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M4.97183 10.4917C5 10.8023 5.21127 11 5.50704 11C5.78873 11 6 10.8023 6.02817 10.5199C6.52016 6.78525 6.63336 6.76387 10.4983 6.03383L10.5211 6.02952C10.8028 5.98716 11 5.78947 11 5.50706C11 5.21053 10.7887 4.99872 10.5211 4.97047C6.64789 4.43389 6.52113 4.3068 6.02817 0.494223C6 0.197689 5.78873 0 5.50704 0C5.21127 0 5 0.197689 4.97183 0.508344C4.51102 4.21832 4.34094 4.25005 0.577071 4.95215L0.478873 4.97047C0.197183 5.01284 0 5.21053 0 5.50706C0 5.80359 0.197183 5.98716 0.535211 6.02952C4.35211 6.63671 4.50704 6.74968 4.97183 10.4917ZM14.5 24C14.1424 24 13.8563 23.7376 13.7967 23.3559C12.8789 16.8914 12.0088 16.0565 5.6675 15.2097C5.27415 15.162 5 14.8638 5 14.494C5 14.1243 5.27415 13.838 5.67942 13.7903C12.0326 13.0866 12.9385 12.1086 13.7967 5.64407C13.8563 5.2624 14.1305 5 14.5 5C14.8695 5 15.1437 5.2624 15.2033 5.64407C16.0972 12.1086 16.9793 13.0508 23.3325 13.7903C23.7258 13.838 24 14.1243 24 14.494C24 14.8757 23.7258 15.162 23.3325 15.2097C16.9674 15.9134 16.0615 16.8914 15.2033 23.3559C15.1437 23.7376 14.8695 24 14.5 24Z" fill=currentColor/>\n</g>\n<defs>\n<clipPath id="clip0_6620_871">\n<rect width="24" height="24" fill="white"/>\n</clipPath>\n</defs>\n</svg>',
      title: "AI",
    },
    iconColor: "single",
    size: "sml",
    textColor: "textPrimary",
    bannerBlockContentRaw: [
      {
        _key: "03ec3ef965ed",
        markDefs: [
          {
            _type: "link",
            link: { to: "/platform/brex-ai" },
            _key: "901632671c37",
          },
        ],
        children: [
          {
            _type: "span",
            marks: ["901632671c37"],
            text: "New! Automate your manual expense work with Brex AI →",
            _key: "9def292b8ef20",
          },
        ],
        _type: "block",
        style: "normal",
      },
    ],
    optOutPages: ["/sales", "/signup", "/platform/brex-ai"],
    optOutPageTypes: ["paidPage", "helpCenterArticle", "jobPage"],
  },
  "300bfb00-8322-49aa-93b8-08eaeeae638e": {
    _id: "300bfb00-8322-49aa-93b8-08eaeeae638e",
    _updatedAt: "2024-09-24T13:29:29Z",
    theme: "PrimaryInk",
    icon: null,
    iconColor: "single",
    size: "sml",
    textColor: "textPrimary",
    bannerBlockContentRaw: [
      {
        markDefs: [
          {
            _type: "link",
            link: { noFollow: false, to: "/release" },
            _key: "6f68de8ae904",
          },
        ],
        children: [
          {
            marks: ["6f68de8ae904"],
            text: "🍁 Fall Release ‘24! New Impact Dashboard, smart search, global bill pay, and more.",
            _key: "eaf39d67da7a0",
            _type: "span",
          },
        ],
        _type: "block",
        style: "normal",
        _key: "fc0824583cf4",
      },
    ],
    optOutPages: ["/sales", "/signup"],
    optOutPageTypes: ["paidPage", "helpCenterArticle", "jobPage"],
  },
  "4144e6b0-bf03-45df-bea2-48904ca0d4ad": {
    _id: "4144e6b0-bf03-45df-bea2-48904ca0d4ad",
    _updatedAt: "2024-02-29T16:04:16Z",
    theme: "PrimaryInk",
    icon: null,
    iconColor: "single",
    size: "sml",
    textColor: "textPrimary",
    bannerBlockContentRaw: [
      {
        _type: "block",
        style: "normal",
        _key: "b1975f85978f",
        markDefs: [
          {
            link: { to: "/journal/winter-release-2024" },
            _key: "6b0ca13a7e0f",
            _type: "link",
          },
        ],
        children: [
          {
            text: "🚀 The Winter '24 Release is here — with smarter bill pay, spend limits, and more >",
            _key: "5e3a93344b460",
            _type: "span",
            marks: ["6b0ca13a7e0f"],
          },
        ],
      },
    ],
    optOutPages: ["/sales", "/signup", "/journal/winter-release-2024"],
    optOutPageTypes: ["paidPage", "helpCenterArticle", "jobPage"],
  },
  "420c1a34-2cb9-4f4b-8207-da676cd2a6d3": {
    _id: "420c1a34-2cb9-4f4b-8207-da676cd2a6d3",
    _updatedAt: "2024-02-29T16:13:40Z",
    theme: "PrimaryPaper",
    icon: {
      color:
        '<svg id="e3YWoSl6QuJ1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 300 300" shape-rendering="geometricPrecision" text-rendering="geometricPrecision">\n<style>\n#smallCircle {\n  animation: smlcircleAnim 2000ms linear infinite normal forwards\n}\n\n@keyframes smlcircleAnim {\n  0% {\n    transform: translate(150px, 150px) scale(0.486111, 0.486111);\n    animation-timing-function: cubic-bezier(0, 0, 0.82, 0.14)\n  }\n\n  25% {\n    transform: translate(150px, 150px) scale(1, 1)\n  }\n\n  75% {\n    transform: translate(150px, 150px) scale(1, 1)\n  }\n\n  100% {\n    transform: translate(150px, 150px) scale(1, 1)\n  }\n}\n\n#smlCircleFade {\n  animation: smlCircleFadeAnim 2000ms linear infinite normal forwards\n}\n\n@keyframes smlCircleFadeAnim {\n  0% {\n    opacity: 0\n  }\n\n  25% {\n    opacity: 0.7\n  }\n\n  75% {\n    opacity: 0.7\n  }\n\n  100% {\n    opacity: 0\n  }\n}\n\n#lrgCircle {\n  animation: lrgCircleAnim 2000ms linear infinite normal forwards\n}\n\n@keyframes lrgCircleAnim {\n  0% {\n    transform: translate(150.000015px, 150.000015px) scale(0.705443, 0.705443)\n  }\n\n  35% {\n    transform: translate(150.000015px, 150.000015px) scale(0.705443, 0.705443);\n    animation-timing-function: cubic-bezier(0.005, 0.69, 1, 1)\n  }\n\n  50% {\n    transform: translate(150.000015px, 150.000015px) scale(1, 1)\n  }\n\n  75% {\n    transform: translate(150.000015px, 150.000015px) scale(1, 1)\n  }\n\n  100% {\n    transform: translate(150.000015px, 150.000015px) scale(1, 1)\n  }\n}\n\n#lrgCircleOuter {\n  animation: lrgCircleFadeAnim 2000ms linear infinite normal forwards\n}\n\n@keyframes lrgCircleFadeAnim {\n  0% {\n    opacity: 0\n  }\n\n  35% {\n    opacity: 0;\n    animation-timing-function: cubic-bezier(0.005, 0.69, 1, 1)\n  }\n\n  50% {\n    opacity: 0.2\n  }\n\n  75% {\n    opacity: 0.2\n  }\n\n  100% {\n    opacity: 0\n  }\n}\n\n</style>\n<g id="smallCircle" transform="translate(150,150) scale(0.486111,0.486111)">\n  <circle id="smlCircleFade" r="102.101" transform="translate(0,0)" opacity="0" fill="none" stroke="#a93f17"\n    stroke-width="7.56302" />\n</g>\n<g id="lrgCircle" transform="translate(150.000015,150.000015) scale(0.705443,0.705443)">\n  <circle id="lrgCircleOuter" r="144.958" transform="translate(-0.000015,-0.000015)" opacity="0" fill="none"\n    stroke="#a93f17" stroke-width="10.084" />\n</g>\n<circle r="49.6324" transform="translate(150 150)" fill="#f46a35" stroke="#a93f17" stroke-width="6.61765" />\n<circle r="17.6471" transform="translate(149.999 150.001)" fill="#fff6f2" /></svg>',
      mono: null,
      title: "Animating Pulse (Banner)",
    },
    iconColor: "multi",
    size: "med",
    textColor: "accent",
    bannerBlockContentRaw: [
      {
        style: "normal",
        _key: "a9e77293023d",
        markDefs: [
          {
            _key: "3f936fcf7cfc",
            _type: "link",
            link: {
              toExternal: "https://www.brex.com/product/business-account",
            },
          },
        ],
        children: [
          {
            _key: "b6a71549d6e5",
            _type: "span",
            marks: ["3f936fcf7cfc"],
            text: "Store your funds with safety and stability in a Brex business account.",
          },
        ],
        _type: "block",
      },
    ],
    optOutPages: [
      "/sales",
      "/signup",
      "/product-tour",
      "/product/business-account",
      "/journal/press",
    ],
    optOutPageTypes: [
      "paidPage",
      "helpCenterArticle",
      "jobPage",
      "pressRelease",
    ],
  },
  "452712ed-3609-448d-8927-f9d7ff1fb360": {
    _id: "452712ed-3609-448d-8927-f9d7ff1fb360",
    _updatedAt: "2025-09-24T19:22:19Z",
    theme: "PrimaryInk",
    icon: null,
    iconColor: "single",
    size: "sml",
    textColor: "textPrimary",
    bannerBlockContentRaw: [
      {
        _type: "block",
        style: "normal",
        _key: "b964bc1384c5",
        markDefs: [
          {
            _type: "link",
            link: { noFollow: false, to: "/product/rewards" },
            _key: "7dfad76dc524",
          },
          {
            link: { to: "/product/rewards", noFollow: false },
            _key: "f3f6edadb979",
            _type: "link",
          },
        ],
        children: [
          {
            _type: "span",
            marks: ["f3f6edadb979"],
            text: " ",
            _key: "9c0a6eecfc51",
          },
          { _key: "c4a126802f2a", _type: "span", marks: [], text: "🍔 " },
          {
            _type: "span",
            marks: ["7dfad76dc524"],
            text: "New: Get DashPass on us! Explore all rewards now >",
            _key: "75881e9d512b",
          },
        ],
      },
    ],
    optOutPages: ["/sales", "/signup", "/product/rewards", "/careers"],
    optOutPageTypes: ["paidPage", "helpCenterArticle", "jobPage"],
  },
  "4dad7b68-bd3a-44ca-907b-5aed298e4ddc": {
    _id: "4dad7b68-bd3a-44ca-907b-5aed298e4ddc",
    _updatedAt: "2024-02-29T16:13:40Z",
    theme: "PrimaryInk",
    icon: {
      color:
        '<svg width="23" height="24" viewBox="0 0 23 24" fill=#000000 xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M22.4742 1.24256C22.6082 0.706767 22.2824 0.163822 21.7467 0.0298573C21.2154 -0.102975 20.6771 0.216159 20.5374 0.743878C20.5365 0.746955 20.5343 0.754025 20.5307 0.76461C20.5219 0.790665 20.505 0.836613 20.4778 0.895821C20.4228 1.01584 20.331 1.17918 20.189 1.34149C19.9278 1.63999 19.4457 1.99999 18.5041 1.99999C18.4706 1.99999 18.4374 2.00035 18.4043 2.00105L16.8648 0.923039C16.3975 0.595822 15.8126 0.483743 15.2575 0.614998L10.2126 1.80769C9.73518 1.92057 9.31588 2.205 9.03448 2.60688L0.5 14.7954L13.6064 23.9726L22.1409 11.7841C22.4223 11.3822 22.5462 10.8909 22.489 10.4037L21.8843 5.25515C21.8177 4.68856 21.5124 4.17735 21.0451 3.85013L20.5844 3.52755C21.0477 3.28772 21.4132 2.97955 21.6941 2.6585C21.9896 2.3208 22.1791 1.98414 22.2959 1.72916C22.3548 1.60087 22.3964 1.49057 22.4247 1.40725C22.4389 1.36549 22.4579 1.30248 22.4579 1.30248L22.4742 1.24256ZM16.1042 2.83203C15.7229 3.16126 15.4288 3.56878 15.2212 4.01841C14.7277 5.08759 14.7344 6.3531 15.0554 7.31622C15.2301 7.84016 15.7964 8.12332 16.3203 7.94868C16.8443 7.77403 17.1274 7.20771 16.9528 6.68376C16.7738 6.14689 16.7806 5.4124 17.0371 4.85657C17.1958 4.51274 17.451 4.22116 17.8922 4.08398L19.8979 5.48844L20.5026 10.637L13.1153 21.1871L3.28546 14.3042L10.6728 3.75404L15.7176 2.56134L16.1042 2.83203Z" fill=#000000/>\n</svg>\n',
      mono: '<svg width="23" height="24" viewBox="0 0 23 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M22.4742 1.24256C22.6082 0.706767 22.2824 0.163822 21.7467 0.0298573C21.2154 -0.102975 20.6771 0.216159 20.5374 0.743878C20.5365 0.746955 20.5343 0.754025 20.5307 0.76461C20.5219 0.790665 20.505 0.836613 20.4778 0.895821C20.4228 1.01584 20.331 1.17918 20.189 1.34149C19.9278 1.63999 19.4457 1.99999 18.5041 1.99999C18.4706 1.99999 18.4374 2.00035 18.4043 2.00105L16.8648 0.923039C16.3975 0.595822 15.8126 0.483743 15.2575 0.614998L10.2126 1.80769C9.73518 1.92057 9.31588 2.205 9.03448 2.60688L0.5 14.7954L13.6064 23.9726L22.1409 11.7841C22.4223 11.3822 22.5462 10.8909 22.489 10.4037L21.8843 5.25515C21.8177 4.68856 21.5124 4.17735 21.0451 3.85013L20.5844 3.52755C21.0477 3.28772 21.4132 2.97955 21.6941 2.6585C21.9896 2.3208 22.1791 1.98414 22.2959 1.72916C22.3548 1.60087 22.3964 1.49057 22.4247 1.40725C22.4389 1.36549 22.4579 1.30248 22.4579 1.30248L22.4742 1.24256ZM16.1042 2.83203C15.7229 3.16126 15.4288 3.56878 15.2212 4.01841C14.7277 5.08759 14.7344 6.3531 15.0554 7.31622C15.2301 7.84016 15.7964 8.12332 16.3203 7.94868C16.8443 7.77403 17.1274 7.20771 16.9528 6.68376C16.7738 6.14689 16.7806 5.4124 17.0371 4.85657C17.1958 4.51274 17.451 4.22116 17.8922 4.08398L19.8979 5.48844L20.5026 10.637L13.1153 21.1871L3.28546 14.3042L10.6728 3.75404L15.7176 2.56134L16.1042 2.83203Z" fill="currentColor"/>\n</svg>\n',
      title: "Discount",
    },
    iconColor: "single",
    size: "sml",
    textColor: "textPrimary",
    bannerBlockContentRaw: [
      {
        _type: "block",
        style: "normal",
        _key: "969b22452ff6",
        markDefs: [
          {
            _key: "5522dfb5b713",
            _type: "link",
            link: { to: "/brex-vs-concur" },
          },
        ],
        children: [
          {
            _type: "span",
            marks: ["5522dfb5b713"],
            text: "Get up to 6 months free by ditching Concur for Brex  >",
            _key: "7f39b3ed09dc0",
          },
        ],
      },
    ],
    optOutPages: ["/sales", "/signup", "/brex-vs-concur", "/versus/ramp"],
    optOutPageTypes: ["helpCenterArticle", "jobPage", "contentHubArticle"],
  },
  "4f794674-7bad-4b10-8bac-758e416b8418": {
    _id: "4f794674-7bad-4b10-8bac-758e416b8418",
    _updatedAt: "2024-02-29T16:13:40Z",
    theme: "PrimaryPaper",
    icon: {
      color:
        '<svg id="e3YWoSl6QuJ1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 300 300" shape-rendering="geometricPrecision" text-rendering="geometricPrecision">\n<style>\n#smallCircle {\n  animation: smlcircleAnim 2000ms linear infinite normal forwards\n}\n\n@keyframes smlcircleAnim {\n  0% {\n    transform: translate(150px, 150px) scale(0.486111, 0.486111);\n    animation-timing-function: cubic-bezier(0, 0, 0.82, 0.14)\n  }\n\n  25% {\n    transform: translate(150px, 150px) scale(1, 1)\n  }\n\n  75% {\n    transform: translate(150px, 150px) scale(1, 1)\n  }\n\n  100% {\n    transform: translate(150px, 150px) scale(1, 1)\n  }\n}\n\n#smlCircleFade {\n  animation: smlCircleFadeAnim 2000ms linear infinite normal forwards\n}\n\n@keyframes smlCircleFadeAnim {\n  0% {\n    opacity: 0\n  }\n\n  25% {\n    opacity: 0.7\n  }\n\n  75% {\n    opacity: 0.7\n  }\n\n  100% {\n    opacity: 0\n  }\n}\n\n#lrgCircle {\n  animation: lrgCircleAnim 2000ms linear infinite normal forwards\n}\n\n@keyframes lrgCircleAnim {\n  0% {\n    transform: translate(150.000015px, 150.000015px) scale(0.705443, 0.705443)\n  }\n\n  35% {\n    transform: translate(150.000015px, 150.000015px) scale(0.705443, 0.705443);\n    animation-timing-function: cubic-bezier(0.005, 0.69, 1, 1)\n  }\n\n  50% {\n    transform: translate(150.000015px, 150.000015px) scale(1, 1)\n  }\n\n  75% {\n    transform: translate(150.000015px, 150.000015px) scale(1, 1)\n  }\n\n  100% {\n    transform: translate(150.000015px, 150.000015px) scale(1, 1)\n  }\n}\n\n#lrgCircleOuter {\n  animation: lrgCircleFadeAnim 2000ms linear infinite normal forwards\n}\n\n@keyframes lrgCircleFadeAnim {\n  0% {\n    opacity: 0\n  }\n\n  35% {\n    opacity: 0;\n    animation-timing-function: cubic-bezier(0.005, 0.69, 1, 1)\n  }\n\n  50% {\n    opacity: 0.2\n  }\n\n  75% {\n    opacity: 0.2\n  }\n\n  100% {\n    opacity: 0\n  }\n}\n\n</style>\n<g id="smallCircle" transform="translate(150,150) scale(0.486111,0.486111)">\n  <circle id="smlCircleFade" r="102.101" transform="translate(0,0)" opacity="0" fill="none" stroke="#a93f17"\n    stroke-width="7.56302" />\n</g>\n<g id="lrgCircle" transform="translate(150.000015,150.000015) scale(0.705443,0.705443)">\n  <circle id="lrgCircleOuter" r="144.958" transform="translate(-0.000015,-0.000015)" opacity="0" fill="none"\n    stroke="#a93f17" stroke-width="10.084" />\n</g>\n<circle r="49.6324" transform="translate(150 150)" fill="#f46a35" stroke="#a93f17" stroke-width="6.61765" />\n<circle r="17.6471" transform="translate(149.999 150.001)" fill="#fff6f2" /></svg>',
      mono: null,
      title: "Animating Pulse (Banner)",
    },
    iconColor: "multi",
    size: "med",
    textColor: "accent",
    bannerBlockContentRaw: [
      {
        children: [
          {
            marks: ["69412170c5ac"],
            text: "Seize opportunities and slay obstacles with our Global CFO Playbook >",
            _key: "f87412b1f09b",
            _type: "span",
          },
          { text: " ", _key: "f86d1d50ce4f", _type: "span", marks: [] },
        ],
        _type: "block",
        style: "normal",
        _key: "f68542691fe8",
        markDefs: [
          {
            _type: "link",
            link: {
              toExternal:
                "https://www.brex.com/resources/the-global-cfos-playbook-registration",
            },
            _key: "69412170c5ac",
          },
        ],
      },
    ],
    optOutPages: ["/sales", "/signup", "/product-tour"],
    optOutPageTypes: [
      "paidPage",
      "helpCenterArticle",
      "jobPage",
      "legalPage",
      "pressRelease",
    ],
  },
  "67e794a1-0e67-40ee-8b95-483a672033d8": {
    _id: "67e794a1-0e67-40ee-8b95-483a672033d8",
    _updatedAt: "2025-08-14T21:23:05Z",
    theme: "PrimaryInk",
    icon: null,
    iconColor: "single",
    size: "sml",
    textColor: "textPrimary",
    bannerBlockContentRaw: [
      {
        children: [
          {
            _key: "206f341e5cc9",
            _type: "span",
            marks: ["92a5a9205ac7"],
            text: "☀️ Summer Release '25! Speed meets control with upgraded Brex AI, purchasing, and policies. →",
          },
        ],
        _type: "block",
        style: "normal",
        _key: "156279cf8086",
        markDefs: [
          {
            _key: "92a5a9205ac7",
            _type: "link",
            link: { noFollow: false, to: "/summer-2025" },
          },
        ],
      },
    ],
    optOutPages: ["/sales", "/signup", "/summer-2025", "/careers"],
    optOutPageTypes: ["paidPage", "helpCenterArticle", "jobPage"],
  },
  "68a2a634-13fe-4020-94a0-bb3a05f2ebe6": {
    _id: "68a2a634-13fe-4020-94a0-bb3a05f2ebe6",
    _updatedAt: "2024-05-03T12:58:11Z",
    theme: "PrimaryInk",
    icon: null,
    iconColor: "single",
    size: "sml",
    textColor: "textPrimary",
    bannerBlockContentRaw: [
      {
        children: [
          { _type: "span", marks: [], text: "🤝 ", _key: "dee3bb58ddeb0" },
          {
            text: "Meet Brex at the Gartner CFO & Finance Executive Conference - May 20-21 in Maryland ->",
            _key: "44dbc10bed2c",
            _type: "span",
            marks: ["b7ead9d21951"],
          },
        ],
        _type: "block",
        style: "normal",
        _key: "0a4caac44916",
        markDefs: [
          {
            _key: "b7ead9d21951",
            _type: "link",
            link: { toExternal: "https://www.brex.com/brex-at-gartner-2024" },
          },
        ],
      },
    ],
    optOutPages: ["/sales", "/signup"],
    optOutPageTypes: ["paidPage", "helpCenterArticle", "jobPage"],
  },
  "6d2bc8c9-bcc7-404b-834f-28b4a1f4db94": {
    _id: "6d2bc8c9-bcc7-404b-834f-28b4a1f4db94",
    _updatedAt: "2024-02-29T16:13:40Z",
    theme: "PrimaryInk",
    icon: {
      color:
        '    <svg\n      width="24"\n      height="24"\n      viewBox="0 0 24 24"\n      fill="none"\n      xmlns="http://www.w3.org/2000/svg"\n    >\n      <path\n        fill-rule="evenodd"\n        clip-rule="evenodd"\n        d="M23.8162 14.1036C23.937 13.4206 24 12.7177 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C12.7177 24 13.4206 23.937 14.1036 23.8162C13.3793 23.3301 12.7509 22.7122 12.2525 21.9969C12.1686 21.999 12.0844 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 12.0844 21.999 12.1686 21.9969 12.2525C22.7122 12.7509 23.3301 13.3793 23.8162 14.1036ZM18 24C21.3137 24 24 21.3137 24 18C24 14.6863 21.3137 12 18 12C14.6863 12 12 14.6863 12 18C12 21.3137 14.6863 24 18 24ZM19 14L15 19H17.5L17 22L21 17H18.5L19 14ZM14.9332 11.7058C14.4111 11.2654 13.7365 11 13 11H11C10.4477 11 10 10.5523 10 10C10 9.44771 10.4477 9 11 9H14V10H16V7H13V4H11V7C9.34315 7 8 8.34315 8 10C8 11.6569 9.34315 13 11 13H13C13.0325 13 13.0646 13.0016 13.0963 13.0046C13.6318 12.4789 14.2515 12.0386 14.9332 11.7058ZM11.4616 15.5338C11.5462 15.3303 11.6235 15.1443 11.6736 15H10V14H8V17H11C11 16.6443 11.253 16.0356 11.4616 15.5338L11.4616 15.5338Z"\n        fill="currentColor"\n      />\n    </svg>\n',
      mono: '    <svg\n      width="24"\n      height="24"\n      viewBox="0 0 24 24"\n      fill="none"\n      xmlns="http://www.w3.org/2000/svg"\n    >\n      <path\n        fill-rule="evenodd"\n        clip-rule="evenodd"\n        d="M23.8162 14.1036C23.937 13.4206 24 12.7177 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C12.7177 24 13.4206 23.937 14.1036 23.8162C13.3793 23.3301 12.7509 22.7122 12.2525 21.9969C12.1686 21.999 12.0844 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 12.0844 21.999 12.1686 21.9969 12.2525C22.7122 12.7509 23.3301 13.3793 23.8162 14.1036ZM18 24C21.3137 24 24 21.3137 24 18C24 14.6863 21.3137 12 18 12C14.6863 12 12 14.6863 12 18C12 21.3137 14.6863 24 18 24ZM19 14L15 19H17.5L17 22L21 17H18.5L19 14ZM14.9332 11.7058C14.4111 11.2654 13.7365 11 13 11H11C10.4477 11 10 10.5523 10 10C10 9.44771 10.4477 9 11 9H14V10H16V7H13V4H11V7C9.34315 7 8 8.34315 8 10C8 11.6569 9.34315 13 11 13H13C13.0325 13 13.0646 13.0016 13.0963 13.0046C13.6318 12.4789 14.2515 12.0386 14.9332 11.7058ZM11.4616 15.5338C11.5462 15.3303 11.6235 15.1443 11.6736 15H10V14H8V17H11C11 16.6443 11.253 16.0356 11.4616 15.5338L11.4616 15.5338Z"\n        fill="currentColor"\n      />\n    </svg>\n',
      title: "Cash Lightning",
    },
    iconColor: "single",
    size: "sml",
    textColor: "textPrimary",
    bannerBlockContentRaw: [
      {
        markDefs: [
          {
            _type: "link",
            link: { to: "/journal/how-brex-is-supporting-svb-customers" },
            _key: "7bde952a5b9e",
          },
        ],
        children: [
          {
            _type: "span",
            marks: ["7bde952a5b9e"],
            text: "Learn how Brex is supporting SVB customers.",
            _key: "849dcae5c85a0",
          },
        ],
        _type: "block",
        style: "normal",
        _key: "09e381e5164f",
      },
    ],
    optOutPages: ["/sales", "/signup", "/product-tour"],
    optOutPageTypes: ["paidPage", "helpCenterArticle", "jobPage"],
  },
  "6e06ef97-5bd5-4f96-a011-b2437ea0cb7b": {
    _id: "6e06ef97-5bd5-4f96-a011-b2437ea0cb7b",
    _updatedAt: "2025-10-08T14:35:24Z",
    theme: "PrimaryInk",
    icon: null,
    iconColor: "single",
    size: "sml",
    textColor: "textPrimary",
    bannerBlockContentRaw: [
      {
        markDefs: [
          {
            _type: "link",
            link: {
              noFollow: false,
              to: "/product/business-account/stablecoins",
            },
            _key: "f76c82fe66a1",
          },
        ],
        children: [
          { _type: "span", marks: [], text: "⚡️ ", _key: "bff6fa15ae3a" },
          {
            _type: "span",
            marks: ["f76c82fe66a1"],
            text: "BE THE FIRST TO EXPERIENCE STABLECOIN PAYMENTS ON BREX!",
            _key: "0e6e758a890a",
          },
          { text: " →", _key: "49b4732c371f", _type: "span", marks: [] },
        ],
        _type: "block",
        style: "normal",
        _key: "a22aa21d7b50",
      },
    ],
    optOutPages: [
      "/sales",
      "/signup",
      "/careers",
      "/product/business-account/stablecoins",
    ],
    optOutPageTypes: ["paidPage", "helpCenterArticle", "jobPage"],
  },
  "75656fdd-1627-4103-8f60-1e16e0abf8ce": {
    _id: "75656fdd-1627-4103-8f60-1e16e0abf8ce",
    _updatedAt: "2025-06-11T18:17:38Z",
    theme: "PrimaryInk",
    icon: null,
    iconColor: "single",
    size: "sml",
    textColor: "textPrimary",
    bannerBlockContentRaw: [
      {
        markDefs: [
          {
            _type: "link",
            link: { noFollow: false, to: "/product/business-account" },
            _key: "766012273161",
          },
        ],
        children: [
          { _key: "64ceffe0b1c0", _type: "span", marks: [], text: "📈 " },
          {
            _type: "span",
            marks: ["766012273161"],
            text: "Brex now offers the highest-returning, lowest-risk treasury product. Period. →",
            _key: "e93dc6186811",
          },
        ],
        _type: "block",
        style: "normal",
        _key: "670a5d460cf8",
      },
    ],
    optOutPages: ["/sales", "/signup"],
    optOutPageTypes: ["paidPage", "helpCenterArticle", "jobPage"],
  },
  "79cc48e5-7a19-4f05-a036-1ba8e4a6d776": {
    _id: "79cc48e5-7a19-4f05-a036-1ba8e4a6d776",
    _updatedAt: "2024-12-12T15:19:51Z",
    theme: "PrimaryInk",
    icon: null,
    iconColor: "single",
    size: "sml",
    textColor: "textPrimary",
    bannerBlockContentRaw: [
      {
        style: "normal",
        _key: "e1e1c72b4fd9",
        markDefs: [
          {
            link: {
              toExternal: "https://www.brex.com/journal/brex-in-founder-mode",
              noFollow: false,
            },
            _key: "8f819d44d32c",
            _type: "link",
          },
        ],
        children: [
          { _type: "span", marks: [], text: "🎉 ", _key: "92da39b537170" },
          {
            _type: "span",
            marks: ["8f819d44d32c"],
            text: "A recap of our progress in 2024, 10 months into founder mode →",
            _key: "13ef6c9c606e",
          },
        ],
        _type: "block",
      },
    ],
    optOutPages: ["/sales", "/signup"],
    optOutPageTypes: ["paidPage", "helpCenterArticle", "jobPage"],
  },
  "80a72c87-4c38-438c-b6ab-7aae11fc3a60": {
    _id: "80a72c87-4c38-438c-b6ab-7aae11fc3a60",
    _updatedAt: "2024-02-29T16:13:40Z",
    theme: "PrimaryPaper",
    icon: {
      color:
        '<svg id="e3YWoSl6QuJ1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 300 300" shape-rendering="geometricPrecision" text-rendering="geometricPrecision">\n<style>\n#smallCircle {\n  animation: smlcircleAnim 2000ms linear infinite normal forwards\n}\n\n@keyframes smlcircleAnim {\n  0% {\n    transform: translate(150px, 150px) scale(0.486111, 0.486111);\n    animation-timing-function: cubic-bezier(0, 0, 0.82, 0.14)\n  }\n\n  25% {\n    transform: translate(150px, 150px) scale(1, 1)\n  }\n\n  75% {\n    transform: translate(150px, 150px) scale(1, 1)\n  }\n\n  100% {\n    transform: translate(150px, 150px) scale(1, 1)\n  }\n}\n\n#smlCircleFade {\n  animation: smlCircleFadeAnim 2000ms linear infinite normal forwards\n}\n\n@keyframes smlCircleFadeAnim {\n  0% {\n    opacity: 0\n  }\n\n  25% {\n    opacity: 0.7\n  }\n\n  75% {\n    opacity: 0.7\n  }\n\n  100% {\n    opacity: 0\n  }\n}\n\n#lrgCircle {\n  animation: lrgCircleAnim 2000ms linear infinite normal forwards\n}\n\n@keyframes lrgCircleAnim {\n  0% {\n    transform: translate(150.000015px, 150.000015px) scale(0.705443, 0.705443)\n  }\n\n  35% {\n    transform: translate(150.000015px, 150.000015px) scale(0.705443, 0.705443);\n    animation-timing-function: cubic-bezier(0.005, 0.69, 1, 1)\n  }\n\n  50% {\n    transform: translate(150.000015px, 150.000015px) scale(1, 1)\n  }\n\n  75% {\n    transform: translate(150.000015px, 150.000015px) scale(1, 1)\n  }\n\n  100% {\n    transform: translate(150.000015px, 150.000015px) scale(1, 1)\n  }\n}\n\n#lrgCircleOuter {\n  animation: lrgCircleFadeAnim 2000ms linear infinite normal forwards\n}\n\n@keyframes lrgCircleFadeAnim {\n  0% {\n    opacity: 0\n  }\n\n  35% {\n    opacity: 0;\n    animation-timing-function: cubic-bezier(0.005, 0.69, 1, 1)\n  }\n\n  50% {\n    opacity: 0.2\n  }\n\n  75% {\n    opacity: 0.2\n  }\n\n  100% {\n    opacity: 0\n  }\n}\n\n</style>\n<g id="smallCircle" transform="translate(150,150) scale(0.486111,0.486111)">\n  <circle id="smlCircleFade" r="102.101" transform="translate(0,0)" opacity="0" fill="none" stroke="#a93f17"\n    stroke-width="7.56302" />\n</g>\n<g id="lrgCircle" transform="translate(150.000015,150.000015) scale(0.705443,0.705443)">\n  <circle id="lrgCircleOuter" r="144.958" transform="translate(-0.000015,-0.000015)" opacity="0" fill="none"\n    stroke="#a93f17" stroke-width="10.084" />\n</g>\n<circle r="49.6324" transform="translate(150 150)" fill="#f46a35" stroke="#a93f17" stroke-width="6.61765" />\n<circle r="17.6471" transform="translate(149.999 150.001)" fill="#fff6f2" /></svg>',
      mono: null,
      title: "Animating Pulse (Banner)",
    },
    iconColor: "multi",
    size: "med",
    textColor: "accent",
    bannerBlockContentRaw: [
      {
        _type: "block",
        style: "normal",
        _key: "f68542691fe8",
        markDefs: [
          {
            link: { toExternal: "https://www.brex.com/product/global" },
            _key: "80d2c0bfd808",
            _type: "link",
          },
        ],
        children: [
          {
            text: "New! Go global with local-currency cards and reimbursements >",
            _key: "f87412b1f09b",
            _type: "span",
            marks: ["80d2c0bfd808"],
          },
        ],
      },
    ],
    optOutPages: ["/sales", "/signup", "/product-tour"],
    optOutPageTypes: [
      "paidPage",
      "helpCenterArticle",
      "jobPage",
      "legalPage",
      "pressRelease",
    ],
  },
  "89e8dd23-a6d9-4ee9-b934-7b3097359d7e": {
    _id: "89e8dd23-a6d9-4ee9-b934-7b3097359d7e",
    _updatedAt: "2024-06-18T13:14:47Z",
    theme: "PrimaryInk",
    icon: null,
    iconColor: "multi",
    size: "med",
    textColor: "textPrimary",
    bannerBlockContentRaw: [
      {
        markDefs: [
          {
            _type: "link",
            link: { to: "/product/business-account" },
            _key: "be1e5bc591c4",
          },
        ],
        children: [
          {
            _key: "d906b25a74fb0",
            _type: "span",
            marks: ["be1e5bc591c4"],
            text: "📣 New on Brex — business banking that takes every dollar further >",
          },
        ],
        _type: "block",
        style: "normal",
        _key: "07d0b1938863",
      },
    ],
    optOutPages: ["/sales", "/signup", "/product-tour", "/release"],
    optOutPageTypes: [
      "paidPage",
      "helpCenterArticle",
      "jobPage",
      "legalPage",
      "pressRelease",
    ],
  },
  "8d7bd7c3-989f-4511-9710-78980f1616cf": {
    _id: "8d7bd7c3-989f-4511-9710-78980f1616cf",
    _updatedAt: "2024-10-15T12:52:40Z",
    theme: "PrimaryInk",
    icon: null,
    iconColor: "single",
    size: "sml",
    textColor: "textPrimary",
    bannerBlockContentRaw: [
      {
        children: [
          {
            text: "🎉 Introducing BrexPay for Navan! Get Brex cards and Navan travel in one enterprise solution ->",
            _key: "4ff022c584d00",
            _type: "span",
            marks: ["5b518a5b6c7e"],
          },
        ],
        _type: "block",
        style: "normal",
        _key: "24d64607ba97",
        markDefs: [
          {
            _type: "link",
            link: {
              toExternal: "https://www.brex.com/brexpay",
              noFollow: false,
            },
            _key: "5b518a5b6c7e",
          },
        ],
      },
    ],
    optOutPages: ["/sales", "/signup"],
    optOutPageTypes: ["paidPage", "helpCenterArticle", "jobPage"],
  },
  "934caa5e-241d-49e3-aa7d-060c1d48c96f": {
    _id: "934caa5e-241d-49e3-aa7d-060c1d48c96f",
    _updatedAt: "2024-09-18T12:32:47Z",
    theme: "PrimaryInk",
    icon: null,
    iconColor: "single",
    size: "sml",
    textColor: "textPrimary",
    bannerBlockContentRaw: [
      {
        style: "normal",
        _key: "7394ef8a00db",
        markDefs: [
          {
            link: {
              noFollow: false,
              toExternal: "https://www.brex.com/product/embedded-finance",
            },
            _key: "b9766ded7cb0",
            _type: "link",
          },
        ],
        children: [
          {
            text: "This one’s for you, B2B software vendors! Unlock revenue and offload risk with ",
            _key: "81884a65a2fb0",
            _type: "span",
            marks: [],
          },
          {
            _type: "span",
            marks: ["b9766ded7cb0"],
            text: "Brex Embedded →",
            _key: "c24fc094c887",
          },
        ],
        _type: "block",
      },
    ],
    optOutPages: ["/sales", "/signup"],
    optOutPageTypes: ["paidPage", "helpCenterArticle", "jobPage"],
  },
  "99b9b718-db3b-4ff8-8787-2690cd9efca3": {
    _id: "99b9b718-db3b-4ff8-8787-2690cd9efca3",
    _updatedAt: "2024-02-29T16:13:40Z",
    theme: "PrimaryPaper",
    icon: {
      color:
        '<svg id="e3YWoSl6QuJ1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 300 300" shape-rendering="geometricPrecision" text-rendering="geometricPrecision">\n<style>\n#smallCircle {\n  animation: smlcircleAnim 2000ms linear infinite normal forwards\n}\n\n@keyframes smlcircleAnim {\n  0% {\n    transform: translate(150px, 150px) scale(0.486111, 0.486111);\n    animation-timing-function: cubic-bezier(0, 0, 0.82, 0.14)\n  }\n\n  25% {\n    transform: translate(150px, 150px) scale(1, 1)\n  }\n\n  75% {\n    transform: translate(150px, 150px) scale(1, 1)\n  }\n\n  100% {\n    transform: translate(150px, 150px) scale(1, 1)\n  }\n}\n\n#smlCircleFade {\n  animation: smlCircleFadeAnim 2000ms linear infinite normal forwards\n}\n\n@keyframes smlCircleFadeAnim {\n  0% {\n    opacity: 0\n  }\n\n  25% {\n    opacity: 0.7\n  }\n\n  75% {\n    opacity: 0.7\n  }\n\n  100% {\n    opacity: 0\n  }\n}\n\n#lrgCircle {\n  animation: lrgCircleAnim 2000ms linear infinite normal forwards\n}\n\n@keyframes lrgCircleAnim {\n  0% {\n    transform: translate(150.000015px, 150.000015px) scale(0.705443, 0.705443)\n  }\n\n  35% {\n    transform: translate(150.000015px, 150.000015px) scale(0.705443, 0.705443);\n    animation-timing-function: cubic-bezier(0.005, 0.69, 1, 1)\n  }\n\n  50% {\n    transform: translate(150.000015px, 150.000015px) scale(1, 1)\n  }\n\n  75% {\n    transform: translate(150.000015px, 150.000015px) scale(1, 1)\n  }\n\n  100% {\n    transform: translate(150.000015px, 150.000015px) scale(1, 1)\n  }\n}\n\n#lrgCircleOuter {\n  animation: lrgCircleFadeAnim 2000ms linear infinite normal forwards\n}\n\n@keyframes lrgCircleFadeAnim {\n  0% {\n    opacity: 0\n  }\n\n  35% {\n    opacity: 0;\n    animation-timing-function: cubic-bezier(0.005, 0.69, 1, 1)\n  }\n\n  50% {\n    opacity: 0.2\n  }\n\n  75% {\n    opacity: 0.2\n  }\n\n  100% {\n    opacity: 0\n  }\n}\n\n</style>\n<g id="smallCircle" transform="translate(150,150) scale(0.486111,0.486111)">\n  <circle id="smlCircleFade" r="102.101" transform="translate(0,0)" opacity="0" fill="none" stroke="#a93f17"\n    stroke-width="7.56302" />\n</g>\n<g id="lrgCircle" transform="translate(150.000015,150.000015) scale(0.705443,0.705443)">\n  <circle id="lrgCircleOuter" r="144.958" transform="translate(-0.000015,-0.000015)" opacity="0" fill="none"\n    stroke="#a93f17" stroke-width="10.084" />\n</g>\n<circle r="49.6324" transform="translate(150 150)" fill="#f46a35" stroke="#a93f17" stroke-width="6.61765" />\n<circle r="17.6471" transform="translate(149.999 150.001)" fill="#fff6f2" /></svg>',
      mono: null,
      title: "Animating Pulse (Banner)",
    },
    iconColor: "multi",
    size: "med",
    textColor: "accent",
    bannerBlockContentRaw: [
      {
        _type: "block",
        style: "normal",
        _key: "997ada8ec743",
        markDefs: [
          {
            _type: "link",
            link: { toExternal: "https://www.brex.com/product/travel" },
            _key: "d546b26beb9b",
          },
        ],
        children: [
          {
            marks: ["d546b26beb9b"],
            text: "Brex travel is here! Book and manage global travel — right in Brex →",
            _key: "042ad63db14d",
            _type: "span",
          },
        ],
      },
    ],
    optOutPages: ["/sales", "/signup", "/product-tour", "/product/travel"],
    optOutPageTypes: [
      "paidPage",
      "helpCenterArticle",
      "jobPage",
      "legalPage",
      "pressRelease",
    ],
  },
  "a1969674-2482-4a85-9411-70424eea4c7d": {
    _id: "a1969674-2482-4a85-9411-70424eea4c7d",
    _updatedAt: "2024-06-04T04:42:18Z",
    theme: "PrimaryInk",
    icon: null,
    iconColor: "multi",
    size: "med",
    textColor: "textPrimary",
    bannerBlockContentRaw: [
      {
        _type: "block",
        style: "normal",
        _key: "59c9d9771bb2",
        markDefs: [
          { _key: "30af88a7906f", _type: "link", link: { to: "/release" } },
        ],
        children: [
          {
            _type: "span",
            marks: ["30af88a7906f"],
            text: "📣 Summer Release ‘24! AI-powered accounting & accruals, card control center, and bill pay rewards >",
            _key: "e6d5bd25fb7a0",
          },
        ],
      },
    ],
    optOutPages: ["/sales", "/signup", "/product-tour", "/release"],
    optOutPageTypes: [
      "paidPage",
      "helpCenterArticle",
      "jobPage",
      "legalPage",
      "pressRelease",
    ],
  },
  "a97b46ef-31e3-4fd7-82b0-fa17a8745c59": {
    _id: "a97b46ef-31e3-4fd7-82b0-fa17a8745c59",
    _updatedAt: "2024-05-14T16:24:27Z",
    theme: "PrimaryInk",
    icon: null,
    iconColor: "single",
    size: "sml",
    textColor: "textPrimary",
    bannerBlockContentRaw: [
      {
        _key: "0a4caac44916",
        markDefs: [
          {
            link: {
              toExternal:
                "https://www.brex.com/journal/press/brex-named-4-on-the-2024-cnbc-disruptor-50",
            },
            _key: "ba6872cf8eda",
            _type: "link",
          },
        ],
        children: [
          { _key: "6357634ecad7", _type: "span", marks: [], text: "📣 " },
          {
            _type: "span",
            marks: ["ba6872cf8eda"],
            text: "Brex named #4 on the 2024 CNBC Disruptor 50 list →",
            _key: "7284653dbbb5",
          },
        ],
        _type: "block",
        style: "normal",
      },
    ],
    optOutPages: ["/sales", "/signup"],
    optOutPageTypes: ["paidPage", "helpCenterArticle", "jobPage"],
  },
  "b6bf14ed-e43d-4251-a0eb-e421d241830a": {
    _id: "b6bf14ed-e43d-4251-a0eb-e421d241830a",
    _updatedAt: "2024-10-10T16:30:15Z",
    theme: "PrimaryInk",
    icon: null,
    iconColor: "single",
    size: "sml",
    textColor: "textPrimary",
    bannerBlockContentRaw: [
      {
        children: [
          {
            _key: "4fef6b1f85600",
            _type: "span",
            marks: [],
            text: "💥 [Webinar] Join us November 6 for a live demo on how to best use Brex. ",
          },
          {
            text: "Register now →",
            _key: "fbdfa1cf194f",
            _type: "span",
            marks: ["86e9dd868ed4"],
          },
        ],
        _type: "block",
        style: "normal",
        _key: "0b5714e3a983",
        markDefs: [
          {
            _type: "link",
            link: {
              toExternal:
                "https://www.brex.com/resources/monthly-product-demo-webinar",
            },
            _key: "86e9dd868ed4",
          },
        ],
      },
    ],
    optOutPages: ["/sales", "/signup"],
    optOutPageTypes: [
      "paidPage",
      "helpCenterArticle",
      "jobPage",
      "legalPage",
      "pressRelease",
    ],
  },
  "e56d345f-77a1-47c5-a4f6-d49848b08ceb": {
    _id: "e56d345f-77a1-47c5-a4f6-d49848b08ceb",
    _updatedAt: "2025-03-06T14:00:21Z",
    theme: "PrimaryInk",
    icon: null,
    iconColor: "multi",
    size: "med",
    textColor: "textPrimary",
    bannerBlockContentRaw: [
      {
        _type: "block",
        style: "normal",
        _key: "b0fb022eeb60",
        markDefs: [
          {
            _type: "link",
            link: { noFollow: false, to: "/spring-2025" },
            _key: "5ce733bb76f2",
          },
        ],
        children: [
          {
            marks: ["5ce733bb76f2"],
            text: "🌱 Spring Release is here! Customize anything. Control everything. →",
            _key: "9bd6243d5ae80",
            _type: "span",
          },
        ],
      },
    ],
    optOutPages: ["/sales", "/signup", "/product-tour", "/release"],
    optOutPageTypes: [
      "paidPage",
      "helpCenterArticle",
      "jobPage",
      "legalPage",
      "pressRelease",
    ],
  },
  "e74984d9-0990-4fa0-9a6a-0241f7a80b0c": {
    _id: "e74984d9-0990-4fa0-9a6a-0241f7a80b0c",
    _updatedAt: "2024-11-08T14:42:19Z",
    theme: "PrimaryInk",
    icon: null,
    iconColor: "single",
    size: "sml",
    textColor: "textPrimary",
    bannerBlockContentRaw: [
      {
        children: [
          { text: "🤝 ", _key: "a1e516fa1609", _type: "span", marks: [] },
          {
            _key: "a679540e4b5b",
            _type: "span",
            marks: ["37e58727122e"],
            text: "Become a Brex accounting partner today — and grow your practice tomorrow →",
          },
        ],
        _type: "block",
        style: "normal",
        _key: "7394ef8a00db",
        markDefs: [
          {
            _type: "link",
            link: {
              toExternal: "https://www.brex.com/partners/accounting",
              noFollow: false,
            },
            _key: "37e58727122e",
          },
        ],
      },
    ],
    optOutPages: ["/sales", "/signup"],
    optOutPageTypes: ["paidPage", "helpCenterArticle", "jobPage"],
  },
  "efb2f506-af2c-4e1b-944b-6677a6cb53f9": {
    _id: "efb2f506-af2c-4e1b-944b-6677a6cb53f9",
    _updatedAt: "2024-02-29T16:13:40Z",
    theme: "PrimaryInk",
    icon: {
      color:
        '<svg width="33" height="32" viewBox="0 0 33 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M8.5 0C6.29086 0 4.5 1.79086 4.5 4V30V31.924L6.3015 31.2484L8.42376 30.4526L10.5704 31.5259L11.1667 31.824L11.763 31.5259L13.8333 30.4907L15.9037 31.5259L16.5 31.824L17.0963 31.5259L19.1667 30.4907L21.237 31.5259L21.8333 31.824L22.4296 31.5259L24.5762 30.4526L26.6985 31.2484L28.5 31.924V30V4C28.5 1.79086 26.7091 0 24.5 0H8.5ZM7.16667 4C7.16667 3.26362 7.76362 2.66667 8.5 2.66667H24.5C25.2364 2.66667 25.8333 3.26362 25.8333 4V28.076L24.9682 27.7516L24.4238 27.5474L23.9037 27.8074L21.8333 28.8426L19.763 27.8074L19.1667 27.5093L18.5704 27.8074L16.5 28.8426L14.4296 27.8074L13.8333 27.5093L13.237 27.8074L11.1667 28.8426L9.09628 27.8074L8.57624 27.5474L8.03184 27.7516L7.16667 28.076V4ZM19.1667 8H13.8333V5.33333H19.1667V8ZM21.8333 13.3333H11.1667V10.6667H21.8333V13.3333ZM11.1667 18.6667H21.8333V16H11.1667V18.6667ZM16.5 24V21.3333H21.8333V24H16.5Z" fill="currentColor"/>\n</svg>\n',
      mono: '<svg width="33" height="32" viewBox="0 0 33 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M8.5 0C6.29086 0 4.5 1.79086 4.5 4V30V31.924L6.3015 31.2484L8.42376 30.4526L10.5704 31.5259L11.1667 31.824L11.763 31.5259L13.8333 30.4907L15.9037 31.5259L16.5 31.824L17.0963 31.5259L19.1667 30.4907L21.237 31.5259L21.8333 31.824L22.4296 31.5259L24.5762 30.4526L26.6985 31.2484L28.5 31.924V30V4C28.5 1.79086 26.7091 0 24.5 0H8.5ZM7.16667 4C7.16667 3.26362 7.76362 2.66667 8.5 2.66667H24.5C25.2364 2.66667 25.8333 3.26362 25.8333 4V28.076L24.9682 27.7516L24.4238 27.5474L23.9037 27.8074L21.8333 28.8426L19.763 27.8074L19.1667 27.5093L18.5704 27.8074L16.5 28.8426L14.4296 27.8074L13.8333 27.5093L13.237 27.8074L11.1667 28.8426L9.09628 27.8074L8.57624 27.5474L8.03184 27.7516L7.16667 28.076V4ZM19.1667 8H13.8333V5.33333H19.1667V8ZM21.8333 13.3333H11.1667V10.6667H21.8333V13.3333ZM11.1667 18.6667H21.8333V16H11.1667V18.6667ZM16.5 24V21.3333H21.8333V24H16.5Z" fill="currentColor"/>\n</svg>\n',
      title: "Expenses",
    },
    iconColor: "single",
    size: "sml",
    textColor: "textPrimary",
    bannerBlockContentRaw: [
      {
        _key: "4852c94e4397",
        markDefs: [
          {
            link: { to: "/resources/debunking-5-common-t-and-e-myths" },
            _key: "88d55d794fb4",
            _type: "link",
          },
        ],
        children: [
          {
            _type: "span",
            marks: [],
            text: "June 23 webinar - Unlearn 5 common T&E myths that are holding you back. ",
            _key: "f4ead9d26fea0",
          },
          {
            _key: "2af1b74e550e",
            _type: "span",
            marks: ["88d55d794fb4"],
            text: "Register now",
          },
        ],
        _type: "block",
        style: "normal",
      },
    ],
    optOutPages: ["/sales", "/signup", "/product-tour"],
    optOutPageTypes: [
      "paidPage",
      "helpCenterArticle",
      "jobPage",
      "legalPage",
      "pressRelease",
    ],
  },
  "faf82f63-94ac-46dc-ac12-53ebdc2582d2": {
    _id: "faf82f63-94ac-46dc-ac12-53ebdc2582d2",
    _updatedAt: "2024-02-29T16:13:40Z",
    theme: "PrimaryInk",
    icon: {
      color:
        '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">\n<g clip-path="url(#clip0_5399_159270)">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM12 22C12.7474 22 13.7509 21.2878 14.6252 19.3644C14.9377 18.6767 15.2093 17.8808 15.4265 17H8.57345C8.79074 17.8808 9.06226 18.6767 9.37483 19.3644C10.2491 21.2878 11.2526 22 12 22ZM8.19682 15H15.8032C15.9306 14.0553 16 13.0485 16 12C16 10.9515 15.9306 9.94466 15.8032 9H8.19682C8.06943 9.94466 8 10.9515 8 12C8 13.0485 8.06943 14.0553 8.19682 15ZM8.57345 7C8.79074 6.11921 9.06226 5.32328 9.37483 4.63563C10.2491 2.71217 11.2526 2 12 2C12.7474 2 13.7509 2.71217 14.6252 4.63563C14.9377 5.32328 15.2093 6.11921 15.4265 7H8.57345ZM17.8196 9C17.9378 9.96135 18 10.9672 18 12C18 13.0328 17.9378 14.0387 17.8196 15H21.5422C21.8396 14.053 22 13.0452 22 12C22 10.9548 21.8396 9.94704 21.5422 9H17.8196ZM20.6622 7H17.48C17.2208 5.8214 16.8712 4.74364 16.4459 3.80802C16.2881 3.4608 16.1143 3.12233 15.9247 2.79955C17.9212 3.65232 19.5839 5.13598 20.6622 7ZM6.51996 7H3.33782C4.4161 5.13598 6.07877 3.65232 8.07531 2.79955C7.88574 3.12233 7.71193 3.4608 7.5541 3.80802C7.12882 4.74364 6.77917 5.8214 6.51996 7ZM2.4578 9H6.18036C6.06223 9.96135 6 10.9672 6 12C6 13.0328 6.06223 14.0387 6.18036 15H2.4578C2.16035 14.053 2 13.0452 2 12C2 10.9548 2.16035 9.94704 2.4578 9ZM16.4459 20.192C16.8712 19.2564 17.2208 18.1786 17.48 17H20.6622C19.5839 18.864 17.9212 20.3477 15.9247 21.2005C16.1143 20.8777 16.2881 20.5392 16.4459 20.192ZM8.07532 21.2005C6.07877 20.3477 4.4161 18.864 3.33782 17H6.51996C6.77917 18.1786 7.12882 19.2564 7.5541 20.192C7.71193 20.5392 7.88574 20.8777 8.07532 21.2005Z" fill="currentColor"/>\n</g>\n<defs>\n<clipPath id="clip0_5399_159270">\n<rect width="24" height="24" fill="currentColor"/>\n</clipPath>\n</defs>\n</svg>\n',
      mono: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM12 22C12.7474 22 13.7509 21.2878 14.6252 19.3644C14.9377 18.6767 15.2093 17.8808 15.4265 17H8.57345C8.79074 17.8808 9.06226 18.6767 9.37483 19.3644C10.2491 21.2878 11.2526 22 12 22ZM8.19682 15H15.8032C15.9306 14.0553 16 13.0485 16 12C16 10.9515 15.9306 9.94466 15.8032 9H8.19682C8.06943 9.94466 8 10.9515 8 12C8 13.0485 8.06943 14.0553 8.19682 15ZM8.57345 7C8.79074 6.11921 9.06226 5.32328 9.37483 4.63563C10.2491 2.71217 11.2526 2 12 2C12.7474 2 13.7509 2.71217 14.6252 4.63563C14.9377 5.32328 15.2093 6.11921 15.4265 7H8.57345ZM17.8196 9C17.9378 9.96135 18 10.9672 18 12C18 13.0328 17.9378 14.0387 17.8196 15H21.5422C21.8396 14.053 22 13.0452 22 12C22 10.9548 21.8396 9.94704 21.5422 9H17.8196ZM20.6622 7H17.48C17.2208 5.8214 16.8712 4.74364 16.4459 3.80802C16.2881 3.4608 16.1143 3.12233 15.9247 2.79955C17.9212 3.65232 19.5839 5.13598 20.6622 7ZM6.51996 7H3.33782C4.4161 5.13598 6.07877 3.65232 8.07531 2.79955C7.88574 3.12233 7.71193 3.4608 7.5541 3.80802C7.12882 4.74364 6.77917 5.8214 6.51996 7ZM2.4578 9H6.18036C6.06223 9.96135 6 10.9672 6 12C6 13.0328 6.06223 14.0387 6.18036 15H2.4578C2.16035 14.053 2 13.0452 2 12C2 10.9548 2.16035 9.94704 2.4578 9ZM16.4459 20.192C16.8712 19.2564 17.2208 18.1786 17.48 17H20.6622C19.5839 18.864 17.9212 20.3477 15.9247 21.2005C16.1143 20.8777 16.2881 20.5392 16.4459 20.192ZM8.07532 21.2005C6.07877 20.3477 4.4161 18.864 3.33782 17H6.51996C6.77917 18.1786 7.12882 19.2564 7.5541 20.192C7.71193 20.5392 7.88574 20.8777 8.07532 21.2005Z" fill="currentColor"/>\n</svg>',
      title: "Global",
    },
    iconColor: "single",
    size: "sml",
    textColor: "textPrimary",
    bannerBlockContentRaw: [
      {
        children: [
          {
            marks: ["cbd147665439"],
            text: "[Analyst webinar] Why top execs are rethinking global spend >",
            _key: "258c753c07d1",
            _type: "span",
          },
        ],
        _type: "block",
        style: "normal",
        _key: "da9b9452c227",
        markDefs: [
          {
            _key: "cbd147665439",
            _type: "link",
            link: {
              toExternal:
                "https://www.brex.com/resources/rethinking-global-spend-register",
            },
          },
        ],
      },
    ],
    optOutPages: ["/sales", "/signup"],
    optOutPageTypes: ["paidPage", "helpCenterArticle", "jobPage"],
  },
};
